import React from 'react';
import { ConfigProvider, Modal, Card, Spin } from 'antd';
import { EmailTemplatesModel } from '@mm/state/model/EmailTemplatesModel';
import { Button } from '@mm/components';
import css from './EmailTemplatesModal.module.css';

type Props = {
  visible: boolean;
  templates: EmailTemplatesModel[];
  loading: boolean;
  onSelect: (template: EmailTemplatesModel) => void;
  onClose: () => void;
};

export const EmailTemplatesModal = ({
  visible,
  templates,
  loading,
  onSelect,
  onClose,
}: Props) => (
  <Modal
    open={visible}
    title="Choose a Template"
    footer={null}
    onCancel={onClose}
    width="100%"
    className={css.modal}
  >
    {loading ? (
      <Spin />
    ) : (
      <div className={css.cardsContainer}>
        <ConfigProvider
          theme={{
            components: {
              Card: {
                colorBgContainer: '#F3F5F8',
              },
            },
          }}
        >
          {templates.map(template => (
            <Card
              key={template.id}
              cover={
                <div className={css.cardCover}>
                  <img
                    className={css.image}
                    alt={template.name}
                    src={template.imageUrl}
                  />
                </div>
              }
              className={css.card}
              actions={[
                <Button
                  key={`choose-${template.id}`}
                  onClick={() => onSelect(template)}
                  css={{ container: css.button }}
                >
                  Choose Template
                </Button>,
              ]}
            >
              {/* Note: we do not need it now, just a sample of what's available on the template
            <Card.Meta title={template.name} description={template.createdAt} /> */}
            </Card>
          ))}
        </ConfigProvider>
      </div>
    )}
  </Modal>
);
